import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, className = "" }) {
  const { add } = useCart();
  const oneSize = product.sizes?.length === 1;
  return (
    <motion.div
      data-testid={`product-card-${product.slug}`}
      className={`group relative overflow-hidden bg-zinc-900 border border-zinc-800 hover:border-[#FF334B]/50 transition-colors ${className}`}
      whileHover={{ scale: 1.02 }}
      transition={{ type: "spring", stiffness: 200, damping: 25 }}
    >
      <Link to={`/product/${product.slug}`} data-testid={`product-link-${product.slug}`} className="block">
        <div className="relative overflow-hidden aspect-[3/4]">
          <img
            src={product.image}
            alt={product.name}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          />
          <span className="absolute top-4 left-4 mono text-[10px] tracking-[0.25em] uppercase bg-black/70 backdrop-blur px-3 py-1.5 text-zinc-300">
            {product.tag}
          </span>
        </div>
        <div className="p-5 flex items-start justify-between gap-3">
          <div>
            <p className="mono text-[10px] tracking-[0.25em] text-zinc-500 uppercase">{product.category}</p>
            <h3 className="font-display font-bold uppercase tracking-tight mt-1 text-base">{product.name}</h3>
          </div>
          <p className="mono text-sm text-zinc-300 whitespace-nowrap">${product.price.toFixed(0)}</p>
        </div>
      </Link>
      <button
        data-testid={`quick-add-${product.slug}`}
        onClick={() => oneSize && add(product, product.sizes[0])}
        className="absolute bottom-24 right-4 bg-[#FF334B] text-white p-3 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-[#d92339]"
        title={oneSize ? "Add to bag" : "Select a size"}
      >
        {oneSize ? <Plus size={16} /> : <Link to={`/product/${product.slug}`}><Plus size={16} /></Link>}
      </button>
    </motion.div>
  );
}
